import { useRef } from "react";
import type { TabHandle } from "./tabs";

export function useTabs() {
	const ref = useRef<TabHandle>(null);

	return {
		ref,
		...ref.current,
	};
}
